module.exports = __webpack_public_path__ + "static/media/PDF_Icon1.18b2ef5a.svg";